export function getSafeLsJSON(lsKey: string, defaultValue: any) {
  try {
    const saved = localStorage.getItem(lsKey);
    return saved ? JSON.parse(saved) : defaultValue;
  } catch (e) {
    return defaultValue
  }
};
